import React from 'react';
import { Activity, DollarSign, LayoutDashboard, TrendingUp, Users } from 'lucide-react';
import { NewLookReturnLink } from '../components/NewLookPrompt/NewLookPrompt';

/**
 * The dashboard's section tabs, shared by the tabbed dashboard (DashboardNew),
 * its skeleton, and the Overview tab (the Analytics page rendered under the
 * same strip). One list so the strip never disagrees between them.
 *
 * Overview is always visible: the Analytics page gates its own cards by
 * report group. The other tabs ride the report-group grants (Forecast uses
 * the revenue grant).
 */
export const DASHBOARD_TABS = [
  { key: 'overview', label: 'Overview', icon: LayoutDashboard, path: '/dashboard/overview', group: null },
  { key: 'revenue', label: 'Revenue', icon: DollarSign, path: '/dashboard/revenue', group: 'revenue' },
  { key: 'forecast', label: 'Forecast', icon: Activity, path: '/dashboard/forecast', group: 'revenue' },
  { key: 'operations', label: 'Operations', icon: Users, path: '/dashboard/operations', group: 'operations' },
  { key: 'financial', label: 'Financial', icon: TrendingUp, path: '/dashboard/financial', group: 'financial' },
];

export const DASHBOARD_TAB_META = Object.fromEntries(DASHBOARD_TABS.map((t) => [t.key, t]));

/** Tabs the viewer may see, given the resolved report groups (null = unrestricted). */
export function visibleDashboardTabs(allowedReportGroups) {
  return DASHBOARD_TABS.filter((tab) => {
    if (!tab.group) return true;
    if (!Array.isArray(allowedReportGroups)) return true;
    return allowedReportGroups.includes(tab.group);
  });
}

export function DashboardTabStrip({ tabs = DASHBOARD_TABS, active, onChange }) {
  if (tabs.length < 2) return null;
  return (
    <div className="new-look-tabs-row">
      <div className="rn-tabs" role="tablist" aria-label="Dashboard sections" data-tour="dashboard-tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = active === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={isActive ? 'rn-active' : undefined}
              onClick={() => onChange(tab.key)}
            >
              <Icon aria-hidden="true" />
              {tab.label}
            </button>
          );
        })}
      </div>
      <NewLookReturnLink />
    </div>
  );
}
